export const DASHBOARD_SCREEN = 'dashboard';
export const CLIENTS_SCREEN = 'clients';
export const TEAMS_SCREEN = 'teams';
